import { LoadingIndicator } from '@/lib/base/foundations/loading-indicator';

import type { CreateMergeFieldBody } from '../../api/fieldMappings';
import type { MailchimpFieldMapping } from '../../types';
import type { MappingUpdate } from '../EditableMappingRow';
import { type AhoyPropertyOption, MappingSections } from '../MappingSections';

interface WizardFieldsStepProps {
  mappings: MailchimpFieldMapping[];
  availableAhoyProperties: AhoyPropertyOption[];
  savingId: number | null;
  creatingProp: string | null;
  isLoading: boolean;
  onUpdate: (mappingId: number, body: MappingUpdate) => void;
  onCreateMergeField: (body: CreateMergeFieldBody) => void;
}

export function WizardFieldsStep({
  mappings,
  availableAhoyProperties,
  savingId,
  creatingProp,
  isLoading,
  onUpdate,
  onCreateMergeField,
}: WizardFieldsStepProps) {
  if (isLoading) {
    return (
      <div className='flex justify-center py-10'>
        <LoadingIndicator size='sm' />
      </div>
    );
  }

  if (mappings.length === 0) {
    return (
      <p className='text-sm text-[var(--color-text-secondary)]'>
        No field mappings found for this audience.
      </p>
    );
  }

  return (
    <MappingSections
      mappings={mappings}
      availableAhoyProperties={availableAhoyProperties}
      savingId={savingId}
      creatingProp={creatingProp}
      onUpdate={onUpdate}
      onCreateMergeField={onCreateMergeField}
    />
  );
}
